import React,{useState,useEffect} from 'react'
import { getStorage, getDownloadURL, ref } from "firebase/storage";
import { app } from '../Firebase/Firebaseapp';
import { useDispatch } from 'react-redux';
import { GetSearchData } from '../Redux/Slice/DataSlice';
import { useNavigate } from 'react-router-dom';



const fireStorage = getStorage(app);

const BrandAll = ({Brand}) => {
  const Dispatch=useDispatch()
  const Navigate=useNavigate()
  const [GetImage, setGetImage] = useState("");
  const [searchData, setsearchData] = useState({
    carName:"",
    Category:"",
    Brand:Brand.Brand,
    Price:""   
  })

  const getBrandImg =(path) => {
      return  getDownloadURL(ref(fireStorage, path))
    }

    const seachByBrand=()=>{
      Dispatch(GetSearchData(searchData))
      Navigate('/cars')

    }


  useEffect(() => {
   getBrandImg(Brand.BrandLogo).then((url) => setGetImage(url))
     console.log("I  am Addbrand")

 }, [])
  
  return (
  <>


<div className="card  h-[25vh] sm:w-[250px] flex justify-center items-center flex-col w-[80%] rounded shadow-md hover:shadow-lg" onClick={seachByBrand}>
        <div className="img h-[60%] w-[100%]">
          <img
            src={GetImage &&GetImage}
            className="h-[100%] w-[100%] object-contain"
            alt=""
          />
        </div>
        <div className="text-xl font-bold">
          {Brand && Brand.Brand}
        </div>

       
      </div>
      


  </>
  )
}

export default BrandAll



